// Anita Week 5 / Day 5 — Проект недели + опыт «Яйцо в солёной воде»
// Grade-3 wrap-up + density experiment.

const day5 = {
  id: 'day-5',
  studentId: 'anita',
  weekId: 'week-5',
  dayId: 'day-5',
  status: 'active',
  title: 'Проект недели: надёжный ответ + опыт «Яйцо в солёной воде» / Week Project + Egg-in-Salt-Water',
  shortTitle: 'Проект недели / Week Project',
  theme: 'Итог недели: карточка надёжного ответа и опыт про плотность. / Week wrap-up: reliable-answer card + density experiment.',
  estimatedTimeLabel: '80–90 минут / 80–90 minutes',
  lessonTiming: { minMinutes: 80, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  courseLayers: ['reading', 'math', 'information-literacy', 'physics', 'logic', 'spelling', 'creative', 'speech'],
  readingLevel: 'grade-2',
  nimnyIntro: 'Нимни: сегодня ты собираешь проект недели и делаешь опыт про плотность. / Today you assemble the project and do the density experiment.',
  goals: ['Сложить баллы 3 источников и найти лучший.', 'Считать воду для опыта (2 × 200 + 50).', 'Работать с 1/2 и 1/4 от 48.', 'Считать время проекта (12 + 8 + 15).', 'Провести опыт с яйцом.', 'Защитить проект родителю.'],
  vocabulary: [
    { term: 'яйцо / egg', definition: 'предмет опыта. / experiment item.' },
    { term: 'соль / salt', definition: 'делает воду плотнее. / makes water denser.' },
    { term: 'вода / water', definition: 'жидкость. / a liquid.' },
    { term: 'тонет / sinks', definition: 'опускается на дно. / goes to bottom.' },
    { term: 'всплывает / floats', definition: 'поднимается наверх. / rises up.' },
    { term: 'опыт / experiment', definition: 'проверка того, что происходит. / a test.' }
  ],
  onlineTasks: [
    { id: 'reading-review-words', type: 'text', title: 'Задание 1 — Слова недели / Week Words',
      prompt: 'Прочитай:\nисточник\nавтор\nдата\nфакт\nмнение\nИИ\nяйцо\nсоль\nвода\nтонет',
      ruPrimaryText: 'Прочитай 10 слов недели.',
      enHelpText: 'Read 10 review words.', answer: 'Попытка чтения.' },
    { id: 'oral-defense-reading', type: 'text', title: 'Задание 2 — Защита проекта / Project Defense',
      prompt: 'Прочитай:\nМой надёжный ответ — с автором и датой.\nЯ проверила источник.\nЯ сделала опыт про плотность.\nЯйцо всплывает в солёной воде.\nМой вывод: соль делает воду плотнее.',
      ruPrimaryText: 'Прочитай 5 фраз защиты.',
      enHelpText: 'My reliable answer has an author. I did the density experiment. Egg floats in salt water.',
      answer: 'Попытка чтения.' },
    { id: 'math-3-sources', type: 'text', title: 'Задание 3 — 3 источника / 3 Sources',
      prompt: 'Анита проверила 3 источника: 8, 6, 10 баллов.\n\nОтветь:\n1. Сумма?\n2. Лучший источник?',
      ruPrimaryText: 'Сумма 3 баллов + сравнение.',
      enHelpText: 'Sum and compare.',
      answer: '1) 8 + 6 + 10 = 24. 2) Третий (10).' },
    { id: 'math-water-ml', type: 'text', title: 'Задание 4 — Вода для опыта / Experiment Water',
      prompt: 'Для опыта — 2 стакана. В каждом 200 мл воды. Потом Анита добавила ещё 50 мл в один стакан.\n\nОтветь:\n1. Сколько мл в двух стаканах?\n2. Сколько мл всего?',
      ruPrimaryText: 'Умножение + сложение.',
      enHelpText: 'Multiply 2 × 200; add 50.',
      answer: '1) 2 × 200 = 400. 2) 400 + 50 = 450 мл.' },
    { id: 'math-project-cards', type: 'text', title: 'Задание 5 — Карточки проекта / Project Cards',
      prompt: 'У Аниты 48 карточек проекта. 1/2 — про факты, 1/4 — про источники, остальные — про опыт.\n\nОтветь:\n1. Сколько про факты?\n2. Сколько про источники?\n3. Сколько про опыт?',
      ruPrimaryText: '1/2 и 1/4 от 48 + остаток.',
      enHelpText: 'Half and quarter of 48; subtract from 48.',
      answer: '1) 48 ÷ 2 = 24. 2) 48 ÷ 4 = 12. 3) 48 − 24 − 12 = 12.' },
    { id: 'math-project-time', type: 'text', title: 'Задание 6 — Время проекта / Project Time',
      prompt: 'Опыт 12 минут, вывод 8 минут, проверка источника 15 минут.\n\nОтветь:\n1. Сколько времени всего?',
      ruPrimaryText: 'Сумма трёх времён.',
      enHelpText: 'Add three times.',
      answer: '1) 12 + 8 + 15 = 35 минут.' },
    { id: 'physics-egg-salt-water', type: 'text', title: 'Задание 7 — Опыт «Яйцо в солёной воде» / Egg-in-Salt-Water',
      prompt: 'Материалы: 2 стакана, вода, соль, ложка, яйцо.\n\nШаги:\n1. Налей воду в 2 стакана.\n2. В один стакан добавь много соли и размешай.\n3. Опусти яйцо в пресную воду.\n4. Опусти яйцо в солёную воду.\n5. Сравни, где тонет, а где всплывает.\n\nЗапиши наблюдения:\nЧто я сделала:\nЧто я увидела:\nГде яйцо тонет:\nГде яйцо всплывает:\nПочему, как я думаю:\nМой вывод:\n\nБезопасность: только с родителем; после опыта вымыть руки; не пить воду из опыта.',
      ruPrimaryText: 'Проведи опыт про плотность с родителем и заполни наблюдения.',
      enHelpText: 'Do the experiment with a parent. Record observations.',
      hint: 'Только с родителем. Не пить воду.',
      answer: 'Open-ended. Ожидаемо: тонет в пресной, всплывает в солёной. Причина — плотность.' },
    { id: 'logic-experiment-density', type: 'text', title: 'Задание 8 — Логика плотности / Density Logic',
      prompt: 'Ответь 1–3 предложения на каждый вопрос:\n1. Почему яйцо всплывает в солёной воде?\n2. Что изменится, если добавить ещё больше соли?\n3. Что изменится, если использовать очень маленький стакан?',
      ruPrimaryText: 'Объясни плотность своими словами.',
      enHelpText: 'Salt water is denser; density makes egg float.',
      answer: 'Ожидаемо: 1) Солёная вода плотнее — легче всплывать. 2) Больше соли — вода ещё плотнее, яйцо ещё лучше всплывает. 3) Маленький стакан труднее для опыта — яйцо может застрять или расплескаться.' },
    { id: 'spelling-day5', type: 'text', title: 'Задание 9 — Правописание недели / Week Spelling',
      prompt: 'Напиши:\nяйцо\nсоль\nвода\nтонет\nвсплывает\nопыт\n\nВставь буквы:\nя_цо\nсо_ь\nв_да\nт_нет\nвсп_ывает\nо_ыт',
      ruPrimaryText: 'Напиши 6 слов и вставь буквы.',
      enHelpText: 'Write 6 experiment words.',
      answer: 'яйцо, соль, вода, тонет, всплывает, опыт.' },
    { id: 'creative-source-table', type: 'text', title: 'Задание 10 — Таблица проекта / Project Table',
      prompt: 'Заполни таблицу для одного выдуманного источника:\nИсточник | Автор есть? | Дата есть? | Доказательство есть? | Вывод',
      ruPrimaryText: 'Заполни таблицу проекта.',
      enHelpText: 'Fill the project source table.',
      answer: 'Open-ended.' },
    { id: 'speech-day5', type: 'text', title: 'Задание 11 — Защита родителю / Defend to Parent',
      prompt: 'Скажи родителю:\nМой надёжный ответ — с автором и датой.\nЯ сделала опыт про плотность.\nЯйцо всплывает в солёной воде.\nМой вывод: соль делает воду плотнее.',
      ruPrimaryText: 'Расскажи родителю про проект и опыт по-русски.',
      enHelpText: 'Defend the project in Russian.',
      answer: 'Accept if defended in Russian.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Начерти таблицу проекта источника (5 колонок).',
    '2. Реши задачи 3–6.',
    '3. Проведи опыт с родителем и заполни наблюдения.',
    '4. Расскажи родителю про плотность.'
  ],
  printWorksheet: {
    title: 'Проект недели + опыт «Яйцо в солёной воде» / Week Project + Egg Experiment',
    subtitle: 'Неделя 5 · День 5 / Week 5 · Day 5',
    pages: [
      { title: 'Маршрут и математика / Route and Math', blocks: [
        { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
        { type: 'text', text: 'Миссия: соберём проект недели и сделаем опыт про плотность.' },
        { type: 'text', text: 'Задание 1 — Слова недели:' },
        { type: 'list', items: ['источник', 'автор', 'дата', 'факт', 'мнение', 'ИИ', 'яйцо', 'соль', 'вода', 'тонет'] },
        { type: 'text', text: 'Задание 2 — Защита проекта:' },
        { type: 'list', items: ['□ Мой надёжный ответ — с автором и датой.', '□ Я проверила источник.', '□ Я сделала опыт про плотность.', '□ Яйцо всплывает в солёной воде.', '□ Мой вывод: соль делает воду плотнее.'] },
        { type: 'text', text: 'Задание 3 — 3 источника:' },
        { type: 'list', items: ['Источник | Баллы', '   1     |   8', '   2     |   6', '   3     |   10', 'Сумма: 8 + 6 + 10 = ___', 'Лучший: ___'] },
        { type: 'text', text: 'Задание 4 — Вода для опыта:' },
        { type: 'list', items: ['2 × 200 = ___ мл', '___ + 50 = ___ мл всего'] },
        { type: 'text', text: 'Задание 5 — Карточки проекта (48 всего):' },
        { type: 'list', items: [
          'Всего              | 48',
          'Про факты (1/2)    | 48 ÷ 2 = ___',
          'Про источники (1/4)| 48 ÷ 4 = ___',
          'Про опыт           | 48 − ___ − ___ = ___'
        ] },
        { type: 'text', text: 'Задание 6 — Время проекта:' },
        { type: 'list', items: ['Опыт: 12  Вывод: 8  Источник: 15', 'Всего: 12 + 8 + 15 = ___ минут'] }
      ] },
      { title: 'Опыт «Яйцо в солёной воде» / Egg-in-Salt-Water', blocks: [
        { type: 'text', text: 'Задание 7 — Опыт. Материалы: 2 стакана, вода, соль, ложка, яйцо.' },
        { type: 'list', items: [
          '1. Налей воду в 2 стакана.',
          '2. В один стакан добавь много соли и размешай.',
          '3. Опусти яйцо в пресную воду.',
          '4. Опусти яйцо в солёную воду.',
          '5. Сравни, где тонет, а где всплывает.'
        ] },
        { type: 'text', text: 'Что я сделала: __________________________________________________________________' },
        { type: 'text', text: 'Что я увидела: __________________________________________________________________' },
        { type: 'text', text: 'Где яйцо тонет: __________________________________________________________________' },
        { type: 'text', text: 'Где яйцо всплывает: ______________________________________________________________' },
        { type: 'text', text: 'Почему, как я думаю: _____________________________________________________________' },
        { type: 'text', text: 'Мой вывод: ______________________________________________________________________' },
        { type: 'text', text: 'Safety: только с родителем; после опыта вымыть руки; не пить воду из опыта.' },
        { type: 'text', text: 'Задание 8 — Логика плотности. Ответь 1–3 предложения на каждый вопрос:' },
        { type: 'list', items: [
          'Почему яйцо всплывает в солёной воде? __________________________________',
          'Что изменится, если добавить ещё соли? _________________________________',
          'Что изменится, если стакан очень маленький? ____________________________'
        ] }
      ] },
      { title: 'Русский, проект и защита / Russian, Project, Defense', blocks: [
        { type: 'text', text: 'Задание 9 — Правописание недели:' },
        { type: 'list', items: ['яйцо   соль   вода   тонет   всплывает   опыт', 'я_цо    со_ь    в_да    т_нет    всп_ывает    о_ыт'] },
        { type: 'text', text: 'Задание 10 — Таблица проекта. Готовая таблица:' },
        { type: 'list', items: [
          'Источник           | Автор есть? | Дата есть? | Доказательство есть? | Вывод',
          '___________________|_____________|____________|_______________________|______',
          '___________________|_____________|____________|_______________________|______'
        ] },
        { type: 'text', text: 'Задание 11 — Защита родителю:' },
        { type: 'list', items: ['□ Мой надёжный ответ — с автором и датой.', '□ Я сделала опыт про плотность.', '□ Яйцо всплывает в солёной воде.', '□ Соль делает воду плотнее.'] },
        { type: 'text', text: 'Parent Check: □ 10 слов  □ 5 фраз защиты  □ 3 источника  □ вода 2 × 200 + 50  □ 1/2 и 1/4 от 48  □ время 35 мин  □ опыт с родителем  □ логика плотности  □ 6 слов  □ таблица проекта  □ защита.' },
        { type: 'text', text: 'Notebook Mode fallback: если нет принтера, начерти таблицу проекта и поля наблюдений в тетради и повтори задания.' }
      ] }
    ]
  },
  parentGuide: {
    whatThisLessonTeaches: 'Собрать проект недели и провести опыт про плотность.',
    howToExplain: 'Скажите: солёная вода плотнее — яйцо всплывает.',
    exampleDialogue: 'Parent: Сумма 3 источников?\nChild: 24.\nParent: Вода всего?\nChild: 450.\nParent: Опыт?\nChild: тонет в пресной, всплывает в солёной.',
    readingSupport: 'Слова «плотнее», «всплывает» — по слогам.',
    russianSpeechGoal: 'Анита говорит: «Соль делает воду плотнее.»',
    check: ['Анита собрала таблицу проекта.', 'Анита провела опыт с родителем.', 'Анита защитила проект по-русски.'],
    spellingCheck: 'Проверить: яйцо, соль, вода, тонет, всплывает, опыт.',
    readingCheck: 'Попытка русского чтения 10 слов и 5 фраз защиты.',
    practicalCheck: 'Опыт проведён над столом/раковиной, поля наблюдений заполнены.',
    discussionPrompts: ['Что удивляет в опыте?', 'Что будет с очень солёной водой?'],
    ifEasy: 'Проверить ещё одну концентрацию соли и записать наблюдение.',
    ifDifficult: 'Оставить только 1 стакан пресной и 1 солёной.',
    commonMistakes: ['«Соль всегда делает воду мокрее.» Правильно: соль делает воду плотнее, а не мокрее.', '«Яйцо всегда тонет.» Правильно: в солёной воде оно всплывает.'],
    projectCriteria: 'Таблица проекта заполнена; опыт с полями наблюдений и вывод про плотность.',
    goal: 'Анита собирает проект недели, проводит опыт про плотность и защищает проект родителю.',
    mathGoal: 'U.S. Grade 3: сумма 3 баллов; 2 × 200 + 50; 1/2 и 1/4 от 48; сумма трёх времён.',
    russianGoal: 'Прочитать 10 слов и 5 фраз защиты; написать 6 слов.',
    readingWritingGoal: 'Заполнить таблицу проекта + 3 логических ответа про плотность.',
    practicalGoal: 'Провести опыт «Яйцо в солёной воде» с родителем и объяснить плотность.',
    parentTheoryCard: {
      title: 'Как объяснить плотность',
      purpose: 'Помочь родителю провести опыт безопасно и объяснить физику простыми словами.',
      keyMessage: 'Солёная вода плотнее пресной, поэтому в солёной воде яйцо всплывает.',
      parentScript: [
        '«В солёную воду мы добавили соль. Она сделала воду тяжелее в том же объёме.»',
        '«В более плотной воде яйцу легче держаться сверху.»',
        '«Если добавить ещё больше соли — вода станет ещё плотнее.»',
        '«После опыта — вымыть руки; не пить воду.»'
      ],
      practiceSteps: [
        'Возьмите 2 одинаковых стакана и налейте по 200 мл воды.',
        'В один добавьте несколько ложек соли и хорошо размешайте.',
        'Опустите яйцо в пресную воду — оно должно утонуть.',
        'Опустите яйцо в солёную воду — оно должно всплыть.',
        'Запишите наблюдения в поля.'
      ],
      paperOnlyNotes: ['Все задания на бумаге.', 'Никаких настоящих переходов по сайтам.'],
      doNotSay: ['Не давай ребёнку пить воду из опыта.', 'Не давай ребёнку тереть глаза после соли.', 'Не оставляй ребёнка одного с водой.']
    },
    rubric: [
      'Русское чтение (10 слов + защита) — 20 баллов / Russian reading and defense — 20 points',
      'Математика (Math 3–6) — 30 баллов / Math correctness with steps — 30 points',
      'Дроби 1/2 и 1/4 от 48 — 5 баллов / Fractions of 48 — 5 points',
      'Опыт про плотность + поля наблюдений — 20 баллов / Density experiment + observation fields — 20 points',
      'Безопасность опыта (родитель + гигиена) — 5 баллов / Safety — 5 points',
      'Логика плотности (3 ответа) — 10 баллов / Density logic — 10 points',
      'Таблица проекта (автор/дата/доказательство) — 5 баллов / Project table — 5 points',
      'Старательность и фокус — 5 баллов / Effort and focus — 5 points'
    ],
    keyMessage: 'Точный вопрос, надёжный источник, факт с доказательством, проверка ИИ, опыт про плотность.',
    mathAnswerKey:
      'math-3-sources: 8 + 6 + 10 = 24; лучший — третий (10).\n' +
      'math-water-ml: 2 × 200 = 400; 400 + 50 = 450 мл.\n' +
      'math-project-cards: 48 ÷ 2 = 24; 48 ÷ 4 = 12; 48 − 24 − 12 = 12.\n' +
      'math-project-time: 12 + 8 + 15 = 35 минут.',
    experimentAnswerKey:
      'Наблюдение: яйцо тонет в пресной воде и всплывает в солёной.\n' +
      'Объяснение: соль делает воду плотнее; в более плотной воде яйцу легче всплывать (плотность).\n' +
      'Что изменится: больше соли — вода ещё плотнее, яйцо ещё лучше всплывает; в маленьком стакане проводить неудобно и рискованно.\n' +
      'Безопасность: только с родителем; после опыта вымыть руки; не пить воду из опыта.',
    spellingAnswerKey: 'яйцо\nсоль\nвода\nтонет\nвсплывает\nопыт',
    answerKey: [
      { taskId: 'reading-review-words', answer: '10 слов недели.' },
      { taskId: 'oral-defense-reading', answer: '5 фраз защиты.' },
      { taskId: 'math-3-sources', answer: '24; третий.' },
      { taskId: 'math-water-ml', answer: '400; 450.' },
      { taskId: 'math-project-cards', answer: '24; 12; 12.' },
      { taskId: 'math-project-time', answer: '35 минут.' },
      { taskId: 'physics-egg-salt-water', answer: 'Тонет в пресной, всплывает в солёной; плотность.' },
      { taskId: 'logic-experiment-density', answer: 'Плотность выше в солёной; больше соли — плотнее; маленький стакан неудобен.' },
      { taskId: 'spelling-day5', answer: '6 слов.' },
      { taskId: 'creative-source-table', answer: 'Заполненная таблица проекта.' },
      { taskId: 'speech-day5', answer: 'Защита по-русски.' }
    ],
    rewardGuidance: 'Базовая награда — 5 нимов. Бонус за полные поля опыта и защиту.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Опыт делать только с родителем, только над столом/раковиной, соблюдать гигиену.',
    safetyNotes: 'Только с родителем. После опыта вымыть руки. Не пить воду из опыта. Не тереть глаза солёными руками. Никаких настоящих сайтов не открывать в проекте.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 5, max: 8, label: 'Награда за проект', display: '5 нимов', bonuses: [
    { id: 'complete-experiment', label: 'Бонус за полные поля наблюдений', amount: 2 },
    { id: 'clear-defense', label: 'Бонус за ясную защиту проекта', amount: 1 }
  ] },
  completionRequirements: {
    requiredTaskIds: ['reading-review-words', 'oral-defense-reading', 'math-3-sources', 'math-water-ml', 'math-project-cards', 'math-project-time', 'physics-egg-salt-water', 'logic-experiment-density', 'spelling-day5', 'creative-source-table', 'speech-day5'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-6-day-1'
};

export default day5;
